export const version = '2.33.1';
//# sourceMappingURL=version.js.map